import { Card, CardActionArea, CardContent, Typography } from '@material-ui/core';
import { useStyles } from './styles';

function MenuLink({ children, href }) {
  const classes = useStyles();

  return(
    <>
      <Card 
        className={classes.card}
      >
        <CardActionArea href={href} target="_">
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              {children}
            </Typography>
            <Typography variant="body2" component="p">
              Clique aqui para acessar
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  );
}

export default MenuLink;